import PropTypes from 'prop-types';
import React from 'react';

require('./style.scss');

const GoogleMap = props =>
  <iframe
    className="google-map"
    frameBorder="0"
    src={`//www.google.com/maps/embed/v1/place?q=${props.latitude},${props.longitude}&key=AIzaSyBEBmRAYpsnUCFOLK3dNmwTlol31lA4Wo0`}
  />;

GoogleMap.propTypes = {
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
};

module.exports = GoogleMap;



// WEBPACK FOOTER //
// ./app/components/common/map/GoogleMap.jsx